document.addEventListener("alpine:init", () => {
  Alpine.data("ThemeSection_MenuDrawer", () => {
    return {
      init() {
        initTeleport(this.$root);
        Alpine.store("modals").register("menu-drawer", "topDrawer");
      },
    };
  });
});
